import React, { useState, useEffect } from 'react';
import DetallesInventario from './DetallesInventario';
import vr from '../../../../../utils/Verifiers';

const RenglonInventarioCampo = (p) => {
    const data = p.data;
    const detalles = p.detalles;
    const index = p.index;
    const keys = p.keys;
    const refresh = p.refresh ?? (() => { });
    useEffect(() => {

    }, [p.data]);

    const concluirRegistro = async (id) => {
        const resp = await vr.getDataAPI('/campo/v2/inventario_campo/concluir', { id: id }, null, null);
        if (!resp.estatus) return;
        refresh();
    }

    return (
        <>
            {
                detalles === index && <tr>
                    <td className='bg-black' colSpan={keys.length + 1}></td>
                </tr>
            }
            <tr>
                {keys.map((key, j) => <td className={'text-center nowrap' + (j === 0 ? ' text-bold text-l' : '')} key={j}>{data[key.key]}</td>)}
                <td className={'text-center nowrap'} colSpan={keys.length}>
                    <button className={'btn btn-sm pt-0 pb-0 ms-1 me-1 round-m shadow btn-danger bg-red3'}
                        disabled={data.estado === 'CONCLUIDO'}
                        onClick={() => concluirRegistro(data.id)}>{data.estado === 'CONCLUIDO' ? 'CONCLUIDO' : 'CONCLUIR'}</button>
                    <button className={'btn btn-sm pt-0 pb-0 ms-1 me-1 round-m shadow btn-' + (detalles === index ? 'dark text-bold' : 'warning')}
                        onClick={() => { if (detalles === index) p.setdetalles(null); else p.setdetalles(index) }}>{detalles === index ? 'CERRAR' : 'DETALLES'}</button>
                </td>
            </tr>
            {detalles === index && <>
                <tr>
                    <td colSpan={keys.length + 1} className='text-center text-bold bg-white p-2'>
                        <DetallesInventario data={data} />
                    </td>
                </tr>
                <tr>
                    <td className={'bg-black'} colSpan={keys.length + 1}></td>
                </tr>
            </>}
        </>
    )
}

export default RenglonInventarioCampo;